export default "__VITE_ASSET__ByR$rcVs__"